import React from "react";
import { gettext } from "../../adapter";
import FilterBoxInput from "./FilterBoxInput";

const FilterBox = ({ filter, title }) => {
  var inputs = filter.map((input) => {
    return <FilterBoxInput input={input} key={input.id} />;
  });

  let filterTitle;
  switch (title) {
    case "type":
      filterTitle = gettext("Type");
      break;
    case "soilMoistureStatus":
      filterTitle = gettext("Soil moisture");
      break;
    case "period":
      filterTitle = gettext("Period");
      break;
    case "owner":
      filterTitle = gettext("Owner");
      break;
    case "group":
      filterTitle = gettext("Group");
      break;
    default:
      filterTitle = title;
  }

  return (
    <div className="filterbox">
      <div className="filterbox--header">{filterTitle}</div>
      <div className="filterbox--content">
        <ul>{inputs}</ul>
      </div>
    </div>
  );
};

export default FilterBox;
